
(window as any)['global'] = window;
import '@angular/localize/init';   